import React from "react";
import {
  Box,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { IPriceItinerary, ISize } from "../interfaces.lowPrice";

import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { DepartureDate } from "./DepartureDate";
import { differenceInDays } from "date-fns";
import { getCellStyles } from "../sharedStyles";
import { useTranslations } from "hooks/useTranslations";

interface IProps {
  size: ISize;
  cheapestCombinations: IPriceItinerary[];
  width: number;
  transformX: number;
  selectedItineraryDates: { departureDate: string; returnDate: string } | null;
  handleTransformX: (number: number) => void;
}

export const DepartureNavigation = (props: IProps) => {
  const {
    size,
    cheapestCombinations,
    width,
    transformX,
    selectedItineraryDates,
    handleTransformX = () => {},
  } = props;

  const { departure } = useTranslations().translations.lowPriceCalendar;

  const t = useTheme();

  const isMobile = useMediaQuery(t.breakpoints.down("md"));

  const listOfDepartureDates = cheapestCombinations.filter(
    (o) => o.returnDate === cheapestCombinations[0].returnDate,
  );

  const getDisabledBefore = () => {
    const itn = listOfDepartureDates.find(
      (elm: IPriceItinerary) => elm.departureDateDifference === transformX,
    );

    const today: Date = new Date();
    const diff = differenceInDays(
      new Date(itn?.departureDate as string),
      today,
    );
    return diff < 2;
  };
  return (
    <Box
      className="wrapper"
      sx={{
        position: "relative",
        width: `calc(100% - ${t.spacing(size.returnDate + size.nav)}) `,
        height: t.spacing(size.date + size.nav),
        overflow: "hidden",
      }}
    >
      <Box
        className="departure-navigation"
        sx={{
          height: t.spacing(size.nav),
          width: `calc(100% + ${t.spacing(size.returnDate + size.nav)}) `,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: t.palette.grey[100],
        }}
      >
        <IconButton
          onClick={() => {
            handleTransformX(-1);
          }}
          size="small"
          disabled={getDisabledBefore()}
        >
          <KeyboardArrowLeftIcon fontSize={isMobile ? "small" : "medium"} />
        </IconButton>
        <Typography
          variant={isMobile ? "bodySmall" : "h5"}
          sx={{ lineHeight: 1, mx: 1, color: t.palette.grey[600] }}
        >
          {departure}
        </Typography>
        <IconButton onClick={() => handleTransformX(1)} size="small">
          <KeyboardArrowRightIcon fontSize={isMobile ? "small" : "medium"} />
        </IconButton>
      </Box>
      <Box
        className="departure-date-list"
        sx={{
          position: "absolute",
          overflow: "visible",
          width: "100%",
          transform: `translateX(${-transformX * width}%)`,
          transition: `transform 250ms 50ms ease-in-out`,
        }}
      >
        {listOfDepartureDates.map((obj: IPriceItinerary) => {
          if (
            obj.departureDateDifference < transformX + 4 &&
            obj.departureDateDifference > transformX - 4
          ) {
            return (
              <Box
                key={
                  "departureDates" +
                  obj.departureDateDifference +
                  obj.returnDateDifference
                }
              >
                <DepartureDate
                  {...props}
                  height={size.date}
                  priceItinerary={obj}
                  sxProps={getCellStyles(
                    false,
                    width,
                    obj.departureDate === selectedItineraryDates?.departureDate,
                    obj.returnDate === selectedItineraryDates?.returnDate,
                    true,
                  )}
                />
              </Box>
            );
          }
        })}
      </Box>
    </Box>
  );
};
